import { format } from 'date-fns';
import { zhCN } from 'date-fns/locale';

export function formatDateGroupLabel(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '未知日期';
  return format(d, 'M月d日', { locale: zhCN });
}

export function groupByDate<T extends { createdAt?: string | null }>(
  items: T[]
): Array<{ label: string; items: T[] }> {
  const map = new Map<string, T[]>();
  for (const item of items) {
    const key = item.createdAt ? formatDateGroupLabel(item.createdAt) : '未知日期';
    const bucket = map.get(key) ?? [];
    bucket.push(item);
    map.set(key, bucket);
  }
  return Array.from(map.entries()).map(([label, groupItems]) => ({
    label,
    items: groupItems,
  }));
}
